if (!customElements.get('collection-list-progress')) {
  class CollectionListProgress extends HTMLElement {
    connectedCallback() {
      this.slider = this.closest('slider-component')?.querySelector('.collection-list--editorial');
      this.track = this.querySelector('.collection-list__progress-track');
      this.thumb = this.querySelector('.collection-list__progress-thumb');

      if (!this.slider || !this.track || !this.thumb) return;

      this.update = this.update.bind(this);
      this.slider.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      requestAnimationFrame(this.update);
    }

    disconnectedCallback() {
      this.slider?.removeEventListener('scroll', this.update);
      window.removeEventListener('resize', this.update);
    }

    update() {
      const scrollableWidth = this.slider.scrollWidth - this.slider.clientWidth;
      const trackWidth = this.track.clientWidth;

      if (scrollableWidth <= 0 || trackWidth <= 0) {
        this.hidden = true;
        return;
      }

      this.hidden = false;

      const visibleRatio = Math.min(1, this.slider.clientWidth / this.slider.scrollWidth);
      const thumbWidth = Math.max(32, trackWidth * visibleRatio);
      const progress = Math.min(1, Math.max(0, this.slider.scrollLeft / scrollableWidth));
      const travel = trackWidth - thumbWidth;

      this.thumb.style.width = `${thumbWidth}px`;
      this.thumb.style.transform = `translateX(${travel * progress}px)`;
    }
  }

  customElements.define('collection-list-progress', CollectionListProgress);
}
